import styled from "styled-components";

const ModalBtnCotainer = styled.div<any>`
    display: flex;
    justify-content: space-between;
    background-color: var(--black_back_color5);
    padding: 10px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    right: 0px;
`;

export default ModalBtnCotainer;